export interface Category {
  id: number;
  name: string;
  icon: string;
  link: string;
  description: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: 'Schuhe',
    icon: 'ri-footprint-line',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Sneaker, Sportschuhe & mehr entdecken',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20pristine%20white%20designer%20sneakers%20with%20sage%20green%20accent%20details%20on%20a%20clean%20light%20beige%20surface%2C%20viewed%20from%20above%20in%20soft%20natural%20daylight%2C%20minimal%20studio%20product%20photography%20style%2C%20warm%20neutral%20background%2C%20subtle%20shadow%2C%20clean%20and%20modern%20aesthetic%2C%20no%20branding%20visible&width=400&height=300&seq=cat-schuhe-01&orientation=landscape',
  },
  {
    id: 2,
    name: 'Hoodies & Pullover',
    icon: 'ri-t-shirt-line',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Gemütliche Hoodies und Sweater',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20sage%20green%20hoodie%20with%20soft%20textured%20cotton%20fabric%20on%20a%20light%20cream%20linen%20background%2C%20warm%20natural%20daylight%20from%20a%20side%20window%2C%20minimalist%20flatlay%20product%20photography%2C%20cozy%20Scandinavian%20aesthetic%2C%20soft%20shadows%2C%20neutral%20warm%20tone%20palette%2C%20no%20logos&width=400&height=300&seq=cat-hoodies-02&orientation=landscape',
  },
  {
    id: 3,
    name: 'T-Shirts',
    icon: 'ri-shirt-line',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Stylische T-Shirts für jeden Tag',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20neatly%20folded%20premium%20cotton%20t-shirts%20in%20cream%20white%20warm%20beige%20and%20soft%20olive%20colors%20stacked%20on%20a%20light%20wooden%20surface%2C%20soft%20natural%20morning%20light%2C%20clean%20minimalist%20product%20photography%2C%20gentle%20fabric%20texture%20visible%2C%20simple%20and%20elegant%20composition%2C%20warm%20neutral%20palette&width=400&height=300&seq=cat-tshirts-03&orientation=landscape',
  },
  {
    id: 4,
    name: 'Jacken',
    icon: 'ri-windy-line',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Jacken & Outerwear Kollektion',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20beige%20lightweight%20trench%20coat%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20a%20warm%20cream%20colored%20wall%2C%20soft%20natural%20daylight%20creating%20gentle%20shadows%2C%20clean%20fashion%20editorial%20style%2C%20elegant%20simplicity%2C%20refined%20texture%20details%20of%20the%20fabric%20visible&width=400&height=300&seq=cat-jacken-04&orientation=landscape',
  },
  {
    id: 5,
    name: 'Hosen & Shorts',
    icon: 'ri-checkbox-blank-line',
    link: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Jeans, Hosen & kurze Hosen',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20well%20fitted%20light%20wash%20denim%20jeans%20neatly%20folded%20on%20a%20warm%20linen%20textile%20background%2C%20soft%20diffused%20daylight%2C%20minimal%20product%20photography%2C%20clean%20composition%2C%20visible%20fabric%20texture%20and%20stitching%20details%2C%20warm%20cream%20and%20beige%20tones&width=400&height=300&seq=cat-hosen-05&orientation=landscape',
  },
  {
    id: 6,
    name: 'Kopfbedeckungen',
    icon: 'ri-sun-line',
    link: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps, Beanies & Hüte',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cream%20colored%20baseball%20cap%20and%20a%20soft%20knitted%20beige%20beanie%20arranged%20on%20a%20light%20wooden%20surface%2C%20gentle%20side%20lighting%20from%20a%20window%2C%20clean%20product%20flatlay%20photography%2C%20warm%20neutral%20aesthetic%2C%20simple%20modern%20composition%2C%20subtle%20texture%20details%20visible&width=400&height=300&seq=cat-caps-06&orientation=landscape',
  },
  {
    id: 7,
    name: 'Sets',
    icon: 'ri-stack-line',
    link: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Komplette Outfit-Sets',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20coordinated%20outfit%20set%20consisting%20of%20a%20cream%20colored%20sweater%20and%20matching%20relaxed%20trousers%20arranged%20together%20on%20a%20light%20linen%20surface%2C%20a%20pair%20of%20white%20sneakers%20placed%20beside%20them%2C%20soft%20natural%20daylight%2C%20editorial%20fashion%20flatlay%20style%2C%20warm%20neutral%20tones%2C%20harmonious%20composition&width=400&height=300&seq=cat-sets-07&orientation=landscape',
  },
  {
    id: 8,
    name: 'Unterwäsche',
    icon: 'ri-checkbox-blank-line',
    link: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Bequeme Basics für jeden Tag',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20basic%20undergarments%20in%20cream%20and%20beige%20tones%20neatly%20folded%20on%20a%20clean%20white%20linen%20surface%2C%20diffused%20natural%20light%2C%20minimal%20studio%20photography%2C%20simple%20and%20clean%20aesthetic%2C%20subtle%20fabric%20texture%2C%20warm%20and%20gentle%20atmosphere&width=400&height=300&seq=cat-unterwaesche-08&orientation=landscape',
  },
  {
    id: 9,
    name: 'Trikots',
    icon: 'ri-trophy-line',
    link: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sporttrikots & Fanartikel',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20green%20and%20white%20sports%20jersey%20with%20subtle%20stripe%20pattern%20on%20a%20light%20beige%20background%2C%20soft%20natural%20window%20light%2C%20clean%20product%20photography%2C%20athletic%20fabric%20texture%20visible%2C%20minimal%20composition%2C%20warm%20neutral%20environment&width=400&height=300&seq=cat-trikots-09&orientation=landscape',
  },
  {
    id: 10,
    name: 'Accessoires',
    icon: 'ri-vip-diamond-line',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Schmuck, Uhren & mehr',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20gold%20toned%20accessories%20including%20a%20delicate%20chain%20necklace%20and%20a%20simple%20classic%20watch%20with%20tan%20leather%20strap%20arranged%20on%20a%20soft%20linen%20surface%2C%20warm%20natural%20daylight%2C%20refined%20product%20photography%2C%20subtle%20shine%20and%20texture%2C%20clean%20sophisticated%20composition&width=400&height=300&seq=cat-accessoires-10&orientation=landscape',
  },
  {
    id: 11,
    name: 'Taschen',
    icon: 'ri-shopping-bag-line',
    link: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Rucksäcke, Taschen & Geldbörsen',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20beige%20canvas%20tote%20bag%20and%20a%20small%20tan%20leather%20crossbody%20purse%20placed%20on%20a%20light%20wooden%20surface%2C%20soft%20natural%20daylight%2C%20clean%20studio%20product%20photography%2C%20warm%20neutral%20palette%2C%20visible%20canvas%20and%20leather%20texture%20details%2C%20simple%20elegant%20composition&width=400&height=300&seq=cat-taschen-11&orientation=landscape',
  },
  {
    id: 12,
    name: 'Gürtel',
    icon: 'ri-link',
    link: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Ledergürtel & Accessoires',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20classic%20tan%20brown%20leather%20belt%20with%20a%20simple%20gold%20buckle%20elegantly%20coiled%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20natural%20side%20lighting%2C%20minimal%20product%20photography%2C%20visible%20leather%20grain%20texture%2C%20clean%20and%20refined%20composition&width=400&height=300&seq=cat-guertel-12&orientation=landscape',
  },
  {
    id: 13,
    name: 'Parfums',
    icon: 'ri-drop-line',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Düfte & Parfums entdecken',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20elegant%20minimalist%20glass%20perfume%20bottle%20with%20amber%20colored%20fragrance%20placed%20on%20a%20warm%20beige%20linen%20surface%20with%20a%20sprig%20of%20dried%20lavender%20beside%20it%2C%20soft%20diffused%20daylight%2C%20subtle%20golden%20reflections%20on%20the%20glass%2C%20refined%20product%20photography%2C%20warm%20and%20sophisticated%20atmosphere&width=400&height=300&seq=cat-parfums-13&orientation=landscape',
  },
  {
    id: 14,
    name: 'Sonstiges',
    icon: 'ri-more-line',
    link: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Weitere spannende Produkte',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20artfully%20arranged%20assortment%20of%20lifestyle%20products%20including%20a%20minimalist%20notebook%20a%20pair%20of%20sunglasses%20and%20a%20small%20decorative%20ceramic%20dish%20on%20a%20light%20linen%20surface%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20tones%2C%20editorial%20flatlay%20style%2C%20clean%20and%20harmonious%20composition%2C%20cozy%20modern%20aesthetic&width=400&height=300&seq=cat-sonstiges-14&orientation=landscape',
  },
];